import bootstrapTheme from 'typography-theme-bootstrap'

import { TypographyOptions } from './types.js'

export const typography: TypographyOptions = {
  /**
   * @tag Vite migration
   * 'typography-theme-bootstrap' module provides a default export and breaks Rollup ESM-CJS interop
   * https://github.com/vitejs/vite/issues/2139#issuecomment-1024852072
   */
  ...(bootstrapTheme.default ? bootstrapTheme.default : bootstrapTheme),
  title: 'System',
  baseFontSize: '16px',
}
